import { render, staticRenderFns } from "./TermsAgreeComponent.vue?vue&type=template&id=cabfc05a"
import script from "./TermsAgreeComponent.vue?vue&type=script&lang=js"
export * from "./TermsAgreeComponent.vue?vue&type=script&lang=js"
import style0 from "./TermsAgreeComponent.vue?vue&type=style&index=0&id=cabfc05a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports